import Lookup from 'src/componentes/select2';

const ToleranciaRiscoFaixasLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/ToleranciaRiscoFaixasLookup"
    clearable
    {...rest}
  />
);

export default ToleranciaRiscoFaixasLookup;
